import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";
import { sessions } from "@api/courses/sessions/path";
import { contents } from "@api/courses/contents/path";
import { reviews } from "@api/courses/reviews/path";
import { accessCodes } from "@api/courses/accessCodes/path";
import { exams } from "@api/courses/exams/path";
import { enrollments } from "@api/courses/enrollments/path";
import { stats } from "@api/courses/stats/path";
import { reviewStats } from "@api/courses/reviewStats/path";

const pathBase = `/courses/`;
const pathById = `${pathBase}:courseId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const courses = {
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  get: apiPathFunc(pathById),
  patch: apiPathFunc(pathById),
  delete: apiPathFunc(pathById),
  sessions,
  contents,
  reviews,
  accessCodes,
  exams,
  enrollments,
  stats,
  reviewStats,
} as const;
